import { FC, useEffect, useState } from 'react'
import gql from 'graphql-tag'
import styled, { css } from 'styled-components'
import {
  CategoryActivityType,
  useJobCategoryBottomSheetQuery,
} from 'generated/graphql'
import BottomSheet, {
  IFBottomSheetProps,
} from '@app.components/BottomSheet/BottomSheet'
import JobCategoryBottomSheetBottom from '../component/bottomSheet/Bottom/JobCategoryBottomSheetBottom'
import JobCategoryBottomSheetMid from '../component/bottomSheet/Mid/JobCategoryBottomSheetMid'
import JobCategoryBottomSheetTop from '../component/bottomSheet/Top/JobCategoryBottomSheetTop'
import useJobCategoryStore from '../store/store.jobCategory'

gql`
  query JobCategoryBottomSheet($filterBy: CategoryFilter) {
    categories(filterBy: $filterBy) {
      ...StoreJobCategoryRoot_category
    }
  }
`

interface IFJobCategoryBottomSheetProps extends IFBottomSheetProps {
  onSubmit: (categoryIds: string[]) => void
  defaultCategoryIds?: string[]
}

const JobCategoryBottomSheet: FC<IFJobCategoryBottomSheetProps> = ({
  defaultCategoryIds,
  onClose,
  onSubmit,
  open,
  ...bottomSheetProps
}) => {
  const resetState = useJobCategoryStore((state) => state.resetState)
  const initCategories = useJobCategoryStore((state) => state.initCategories)

  const [firstLoading, setFirstLoading] = useState<boolean>(true)

  const { loading, data } = useJobCategoryBottomSheetQuery({
    variables: {
      filterBy: {
        activityType: CategoryActivityType.RECRUIT,
        parentId: null,
      },
    },
    onCompleted: () => {
      setFirstLoading(false)
    },
    notifyOnNetworkStatusChange: true,
  })

  useEffect(() => {
    if (data?.categories) {
      resetState()
      const validCategories = data.categories.filter(
        (category) => category !== null,
      )
      initCategories(validCategories, defaultCategoryIds)
    }
  }, [open, data])

  return (
    <StyledWrapper onClose={onClose} open={open} {...bottomSheetProps}>
      {loading || firstLoading ? (
        'loading'
      ) : (
        <>
          <JobCategoryBottomSheetTop
            onClose={() => {
              onClose && onClose()
            }}
          />
          <JobCategoryBottomSheetMid />
          <JobCategoryBottomSheetBottom onSubmit={onSubmit} />
        </>
      )}
    </StyledWrapper>
  )
}

export default JobCategoryBottomSheet

const StyledWrapper = styled(BottomSheet)`
  ${({ theme }) => css`
    display: flex;
    border: 1px solid ${theme.line.line_2};
    width: 100%;
    height: 335px;

    .group-categories {
      width: 200px;
    }
    .item-categories {
      flex: 1;
    }

    .fixed-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: #ebebeb #ffffff00;

      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: #ffffff00;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #ebebeb;
      }
    }
  `}
`
